export default "__VITE_ASSET__7273e6ab__"